import type { VoidFunctionComponent } from 'react';

import SettingsPageHeader from '../../../../../shared/settings/SettingsPageHeader';

const ReleaseGroupsSettingsReports: VoidFunctionComponent = () => {
  return (
    <SettingsPageHeader heading="Reports" />
  );
};

export default ReleaseGroupsSettingsReports;
